import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
  transferSessionIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const executeInstantTransfer = {
  name: "executeInstantTransfer" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    sourceStorageLocationId: storageLocationIdFormat.schema,
    destinationStorageLocationId: storageLocationIdFormat.schema,
    productId: productIdFormat.schema,
    quantity: z.number().int().positive().max(1_000_000),
  }),
  output: z.object({
    success: z.boolean(),
    transferSessionId: transferSessionIdFormat.schema.optional(),
    error: z.string().optional(),
  }),
};

export type ExecuteInstantTransferInput = z.infer<
  typeof executeInstantTransfer.input
>;

export type ExecuteInstantTransferOutput = z.infer<
  typeof executeInstantTransfer.output
>;
